import { render, staticRenderFns } from "./PeriodInfo.vue?vue&type=template&id=916ee3e0&"
import script from "./PeriodInfo.vue?vue&type=script&lang=ts&"
export * from "./PeriodInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports